<template>
  <el-dialog :title="titleName" :visible.sync="dialogVisible" @close="$emit('update:visible',false)"
             :close-on-click-modal="false">
    <div class="dialog_conwrap-qrcode">
      <div class="qrcode_img_box_body"
           v-loading="imgLoading"
           element-loading-text="拼命加载中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.3)">
        <img :src="userQrcodeImg" alt class="qrcode_img_box" width="150" height="150"/>
      </div>
      <p v-if="qrcodeType==1">员工：{{username}}</p>
      <p v-if="qrcodeType==2">{{qrcodeStatus==1?'商品：'+username:'小程序主页：'+username}}</p>
    </div>
    <div class="">
      <el-row class="qcode-title qrcode-list">
        <el-col :span="10">
          <p>尺寸</p>
        </el-col>
        <el-col :span="10">
          <p>使用场景</p>
        </el-col>
        <el-col :span="4">
          <p>操作</p>
        </el-col>
      </el-row>
      <el-row class="qrcode-list">
        <el-col :span="10">
          <p>280X280像素</p>
        </el-col>
        <el-col :span="10">
          <p>名片、传单、桌贴</p>
        </el-col>
        <el-col :span="4">
          <el-button @click="downLoad(1)" :loading="loading1" size="small">下载</el-button>
          <!--<a href="https://geekjc-img.geekjc.com/logo.png" download="Qrcode.png">下载</a>-->
        </el-col>
      </el-row>
      <el-row class="qrcode-list">
        <el-col :span="10">
          <p>500X500像素</p>
        </el-col>
        <el-col :span="10">
          <p>传单、杂志、展板</p>
        </el-col>
        <el-col :span="4">
          <el-button @click="downLoad(2)" :loading="loading2" size="small">下载</el-button>
          <!--<a href="https://geekjc-img.geekjc.com/logo.png" download="Qrcode.png">下载</a>-->
        </el-col>
      </el-row>
      <el-row class="qrcode-list">
        <el-col :span="10">
          <p>1000X1000像素</p>
        </el-col>
        <el-col :span="10">
          <p>易拉宝、横幅、户外广告</p>
        </el-col>
        <el-col :span="4">
          <el-button @click="downLoad(3)" :loading="loading3" size="small">下载</el-button>
          <!--<a href="https://yunzhidata.oss-cn-hangzhou.aliyuncs.com/images/2019-10-12/1570845638.png" download="Qrcode">下载</a>-->
          <!--<a href="https://geekjc-img.geekjc.com/logo.png" download="Qrcode.png">下载</a>-->
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "QRcodeDialog",
    props: ["visible", "qrcodeId", "username", "qrcodeType", "qrcodeStatus"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        userQrcodeImg: '',
        imgType1: '',
        imgType2: '',
        imgType3: '',
        imgLoading: true,
        loading1: false,
        loading2: false,
        loading3: false,
        titleName: null
      };
    },
    created() {
      // qrcodeType 1 角色员工二维码 2 推广二维码
      if (this.qrcodeType === 1) {
        this.titleName = '员工'
      } else {
        this.titleName = '小程序码'
      }
      this.queryQr();
    },
    methods: {
      // 查询二维码
      queryQr() {
        let params;
        let apiRespon;
        let _this = this;
        if (this.qrcodeType === 1) {
          params = {em_id: this.qrcodeId};
          apiRespon = api.employee_download
        } else if (this.qrcodeType === 2) {
          // qrcodeStatus (0小程序页、1商品) qrcodeType 必须为2
          params = {item_id: this.qrcodeId, type: this.qrcodeStatus};
          apiRespon = api.companyadmin_path_download
        }
        this.axios
            .post(apiRespon, params)
            .then(response => {
              // console.log("小程序-推广路径", response.data)
              if (response.data.code == 0) {
                // if (this.qrcodeType === 1) {
                  this.userQrcodeImg = response.data.qrcode
                  let firstImg = new Image();
                  firstImg.onload = function () {
                    // 做初始化动作
                    _this.imgLoading = false;
                  }
                  firstImg.src = response.data.qrcode
                // } else if(this.qrcodeType === 2){
                //   this.userQrcodeImg = response.data.qrcode
                // }
              } else {
              }
            })
            .catch(response => {
            });
      },
      downLoad(option) {
        let alink = document.createElement("a");
        this['loading' + option] = true;
        if (!this['imgType' + option]) {
          // 推广码 companyadmin_path_get_qrcode
          let params;
          let apiRespon;
          // qrcodeType 1 员工 2 推广
          let downQrcodeName;

          if (this.qrcodeType === 1) {
            params = {em_id: this.qrcodeId, type: option};
            apiRespon = api.employee_get_qrcode
            if(option===1){
              downQrcodeName = 'QrcodeUser@280x280'
            }else if(option===2){
              downQrcodeName = 'QrcodeUser@500x500'
            }else if(option===3){
              downQrcodeName = 'QrcodeUser@1000x1000'
            }
          } else if (this.qrcodeType === 2) {
            // qrcodeStatus (0小程序页、1商品) qrcodeType 必须为2
            params = {item_id: this.qrcodeId, type: option,data_type:this.qrcodeStatus};
            apiRespon = api.companyadmin_path_get_qrcode
            if(option===1){
              downQrcodeName = 'QrcodeSmall@280x280'
              if(this.qrcodeStatus===1){
                downQrcodeName = 'QrcodeGoods@280x280'
              }
            }else if(option===2){
              downQrcodeName = 'QrcodeSmall@500x500'
              if(this.qrcodeStatus===1){
                downQrcodeName = 'QrcodeGoods@500x500'
              }
            }else if(option===3){
              downQrcodeName = 'QrcodeSmall@1000x1000'
              if(this.qrcodeStatus===1){
                downQrcodeName = 'QrcodeGoods@1000x1000'
              }
            }
          }
          this.axios
              .post(apiRespon, params)
              .then(response => {
                if (response.data.code == 0) {
                  this['imgType' + option] = response.data.qrcode
                  this.downloadIamge(response.data.qrcode, downQrcodeName, option)
                } else {
                }
              })
              .catch(response => {
              });
        } else {
          this.downloadIamge(this['imgType' + option], 'Qrcode', option)
        }
      },
      downloadIamge(imgsrc, name, option) {//下载图片地址和图片名
        // let image = new Image();
        let _this = this;
        // 解决跨域 Canvas 污染问题
        let image = document.createElement('img');
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
          let a = document.createElement("a"); // 生成一个a元素
          let event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
          _this['loading' + option] = false;
        };
        image.src = imgsrc;
      }
    }
  };
</script>


